import { render, staticRenderFns } from "./SideToolbar.vue?vue&type=template&id=295e299a&scoped=true&"
import script from "./SideToolbar.vue?vue&type=script&lang=js&"
export * from "./SideToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SideToolbar.vue?vue&type=style&index=0&id=295e299a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e299a",
  null
  
)

export default component.exports